/*
 * TripPoints API — dispatches to the localStorage mock or the real HTTP backend
 * based on USE_MOCK_API. Signatures are identical across both.
 */
import { USE_MOCK_API } from './httpClient'
import * as mock from './points.mock'
import * as http from './points.http'

const impl = USE_MOCK_API ? mock : http

export const listPoints = impl.listPoints
export const addPoint = impl.addPoint
export const updatePoint = impl.updatePoint
export const deletePoint = impl.deletePoint
export const reorderPoints = impl.reorderPoints
